// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
// TaskStatus describes the status a task can have
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["COMPLETE"] = "COMPLETE";
    TaskStatus["INCOMPLETE"] = "INCOMPLETE";
})(TaskStatus || (TaskStatus = {}));
export var TaskStatus_index;
(function (TaskStatus_index) {
    TaskStatus_index[TaskStatus_index["COMPLETE"] = 0] = "COMPLETE";
    TaskStatus_index[TaskStatus_index["INCOMPLETE"] = 1] = "INCOMPLETE";
})(TaskStatus_index || (TaskStatus_index = {}));
// EventType describes the type of an event
export var EventType;
(function (EventType) {
    EventType["EVENT_UNSPECIFIED"] = "EVENT_UNSPECIFIED";
    EventType["EVENT_START_TASK"] = "EVENT_START_TASK";
    EventType["EVENT_COMPLETE_TASK"] = "EVENT_COMPLETE_TASK";
    EventType["EVENT_GUIDE_DISMISS"] = "EVENT_GUIDE_DISMISS";
    EventType["EVENT_GUIDE_STEP_ACTION"] = "EVENT_GUIDE_STEP_ACTION";
    EventType["EVENT_GUIDE_STEP"] = "EVENT_GUIDE_STEP";
})(EventType || (EventType = {}));
export var EventType_index;
(function (EventType_index) {
    EventType_index[EventType_index["EVENT_UNSPECIFIED"] = 0] = "EVENT_UNSPECIFIED";
    EventType_index[EventType_index["EVENT_START_TASK"] = 1] = "EVENT_START_TASK";
    EventType_index[EventType_index["EVENT_COMPLETE_TASK"] = 2] = "EVENT_COMPLETE_TASK";
    EventType_index[EventType_index["EVENT_GUIDE_DISMISS"] = 3] = "EVENT_GUIDE_DISMISS";
    EventType_index[EventType_index["EVENT_GUIDE_STEP_ACTION"] = 4] = "EVENT_GUIDE_STEP_ACTION";
    EventType_index[EventType_index["EVENT_GUIDE_STEP"] = 5] = "EVENT_GUIDE_STEP";
})(EventType_index || (EventType_index = {}));
// OnboardingTasksAPI Handles the endpoints related to the onboarding tasks functionality.
// The endpoints are implemented in the insys-onboarding service.
export const OnboardingTasksAPI = {
    // GetTasksStatusByLocationID Returns status of all tasks for a given locationID
    // rpc GetTasksStatusByLocationID(GetTasksStatusByLocationIDRequest) returns (GetTasksStatusByLocationIDResponse) {
    //   option (google.api.http) = {
    //     get: "/tasks"
    //   };
    // }
    // GetModulesAndTasksByLocationID Returns all the modules and tasks for a given locationID
    GetModulesAndTasksByLocationID(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/modules-tasks?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // DeleteCompletedTaskByLocationIDAndTaskID updates the completed_at field to be null in location_tasks table
    // for the given combination of location and task
    // DANGER: NOT TO BE USED UNDER NORMAL CIRCUMSTANCES IN PRODUCTION.
    DeleteCompletedTaskByLocationIDAndTaskID(fn, req) {
        try {
            fm.validateUrlParam(req["taskId"], "taskId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insys/onboarding/v1/onboarding-tasks/tasks/completed/${req["taskId"]}?${fm.renderURLSearchParams(req, ["taskId"])}`, { method: "DELETE" });
    },
    // MarkLocationTaskCompleted sets completed_at and completion_type for a given location and task
    MarkLocationTaskCompleted(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/tasks`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // CreateTaskEvent will create an entry in task_events table
    CreateTaskEvent(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/events`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // CompleteUserTask will mark a task as complete for a given user and task
    CompleteUserTask(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/user-tasks`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // GetUserTaskByUserID will return all the completed user tasks for a given user
    GetUserTasksByUserID(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/user-tasks?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetTaskEvents will return all the events for a given user and task name or locationID
    GetTaskEvents(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/events?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetAccountOwnerInfo returns the account owner contact info
    GetAccountOwnerInfo(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/account-owner?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetTaskStepsByTaskID returns all the steps for a given task id
    GetTaskStepsByTaskID(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/task-steps?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetCSMContactPopupStatusByUserIDAndLocationID returns whether a csm contact is already shown
    GetCSMContactPopupStatusByUserIDAndLocationID(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/contact-pop-up?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // DEPRECATED
    // GetOnboardingStatusBySlugs returns whether locations have been onboarded or not
    //  rpc GetOnboardingStatusBySlugs(GetOnboardingStatusBySlugsRequest) returns (GetOnboardingStatusBySlugsResponse) {
    //    option (google.api.http) = {
    //      get: "/onboarding-status"
    //    };
    //  }
    // GetOnboardingStatusByLocationIDs returns whether locations have been onboarded or not based on the location ids
    GetOnboardingStatusByLocationIDs(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-tasks/onboarding-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
